import '.j{display:flex;}.ssr-plugin'
import '.v{flex-direction:column;}.ssr-plugin'
import '.b0{align-items:flex-start;}.ssr-plugin'
import '.u{gap:1.5rem;}.ssr-plugin'
import '.e1{background:var(--shades-white);}.ssr-plugin'
import '.ab{flex-direction:row;}.ssr-plugin'
import '.ex{justify-content:flex-start;}.ssr-plugin'
import '.jd{gap:2.5rem;}.ssr-plugin'
import '.cw{flex-wrap:wrap;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.b1{gap:0.5rem;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'

export interface NutshellItem {
  total: string | number
  subtitle: string
}

export interface NutshellProps {
  heading: string
  items: NutshellItem[]
  style?: Style
}

export const Nutshell = ({ heading, items, style }: NutshellProps) => {
  return (
    <styled.div className="j v b0 u e1"
      data-testid="nutshell"
      style={{
        ...style,
      }}
    >
      {/* Heading */}
      <Title.H4
        style={{
          color: 'var(--primary-blue)',
          textAlign: 'center',
          margin: 0,
        }}
      >
        {heading}
      </Title.H4>

      {/* Data Points Container */}
      <div className="j ab ex b0 jd cw"
      >
        {items.map((item, index) => (
          <div className="j v r b1"
            key={index}
          >
            {/* Total Number */}
            <Title.H1
              style={{
                fontSize: '4rem',
                fontWeight: '700',
                lineHeight: '100%',
                margin: 0,
                color: 'var(--primary-blue)',
                fontFamily: 'FunnelDisplay',
              }}
            >
              {item.total}
            </Title.H1>

            {/* Subtitle */}
            <Text.Medium
              style={{
                color: 'var(--primary-blue)',
                opacity: 0.6,
                margin: 0,
                textAlign: 'center',
              }}
            >
              {item.subtitle}
            </Text.Medium>
          </div>
        ))}
      </div>
    </styled.div>
  )
}
